<div class="login-body">
    <div class="login-panel p-fluid">
        <div class="login-container--overlay"></div>
        <div class="p-col login-container" style="padding-bottom: 20px;">
            <div class="login-container--content">
                <p>Forgot your password?</p>
                <form [formGroup]="loginForm">
                    <div class="ui-g-12">
                        <input type="text" autocomplete="off" class="p-inputtext p-corner-all p-component"
                            placeholder="Email" formControlName="email">
                    </div>
                    <div class="ui-g-12 button-container">
                        <button type="button" pButton label="Send Reset Link" icon="pi pi-send" iconPos="left"
                            class="raised-btn p-button-warning" (click)="sendResetLink()">
                        </button>
                    </div>
                </form>
                <div>
                    <a routerLink="/login"> Back to login </a>
                </div>
            </div>
        </div>

        <div class="stripe"></div>
        <p style="margin-left: -17px;position: inherit;">Not yet registered? <a routerLink="/signup"> Register here </a>
        </p>
        <div class="stripe"></div>
        <div class="p-col login-container" style="padding-top: 10px;">
        </div>
    </div>
</div>